export const SAVE_FORMS = "SAVE_FORMS";
export const CLEAR_FORMS = "CLEAR_FORMS"

export const SAVE_POST_FORM_COLLECTIONS = "SAVE_POST_FORM_COLLECTIONS";
export const CLEAR_POST_FORM_COLLECTIONS = "CLEAR_POST_FORM_COLLECTIONS"

export const SAVE_CANNED_RESPONSES = "SAVE_CANNED_RESPONSES";
export const CLEAR_CANNED_RESPONSES = "CLEAR_CANNED_RESPONSES"